
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <h5>{{ 'affiliate_popup.headline' | translate }}<br />{{ 'affiliate_popup.sub_headline' | translate }}</h5>
    <p *ngIf="person !== ''">
      [{{ person }}] <span>{{ 'affiliate_popup.text_1' | translate }}</span>
    </p>
    <p [innerHTML]="'affiliate_popup.text_2' | translate"></p>
    <app-form-button class="full-width primary __ga__btn-guest-welcome" (click)="closeAndRegister()">
      Register
    </app-form-button>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/affiliate-modal.component.ts.ModalAffiliateComponent.html